class HttpClient
{
    constructor(baseURL = '', defaultHeaders = {})
    {
        this.baseURL = baseURL;
        this.defaultHeaders = defaultHeaders;
    }

    async RequestAsync(method, url, params = null, body = null)
    {
        let fullURL = this.baseURL + url;

        let config =
        {
            method,
            headers: this.defaultHeaders,
        };

        if(params != null)
        {
            fullURL += "?" + new URLSearchParams(params).toString();
        }

        if(body != null)
        {
            config.body = new URLSearchParams(body).toString();
            config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
        }

        try {
            const response = await fetch(fullURL, config);
            // Trigger custom event with full response details
            this.dispatchAjaxCompleteEvent({
                method,
                url: fullURL,
                response,
                params,
                body
            });
            if (!response.ok) {
                const error = await response.json().catch(() => ({ message: 'Request failed' }));
                throw { status: response.status, ...error };
            }

            const json = await response.json().catch(() => null);
            return { status: response.status, json };
        } catch (error) {
            throw { message: error.message || 'Request failed', status: error.status || 500, ...error };
        }
    }

    GetAsync(url, params)
    {
        return this.RequestAsync('GET', url, params, null);
    }

    PostAsync(url, params, body)
    {
        return this.RequestAsync('POST', url, params, body);
    }
    dispatchAjaxCompleteEvent(details) {
        const event = new CustomEvent('customAjaxComplete', {
            detail: {
                xhr: {
                    getResponseHeader: (name) => details.response?.headers?.get(name),
                    responseText: details.response ? JSON.stringify(details.response) : null,
                    status: details.response?.status || details.error?.status,
                },
                settings: {
                    url: details.url,
                    method: details.method
                }
            }
        });
        document.dispatchEvent(event);
    }
}

export default HttpClient;